// extracted by mini-css-extract-plugin
module.exports = {"radio":"ReasonCategory-module__radio___2qfG8"};